import { DOCUMENT } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Component, Inject, OnInit } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { CssMapService } from "./shared/helper/css-mapper.service";
import { TimeZoneHelperService } from "./shared/helper/timezonehelper.service";
import { SharedDataService } from "./shared/sharedData.service";
import * as _ from "lodash";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.css"],
    standalone: false
})
export class AppComponent implements OnInit {
    constructor(
        private cookieService: CookieService,
        private tzHelper: TimeZoneHelperService,
        private _sharedData: SharedDataService,
        private http: HttpClient,
        @Inject(DOCUMENT) private document: Document
    ) {}
    title = "talent";

    setCookies() {
        this.cookieService.set(
            "Z_Client_Offset",
            this.tzHelper.getTimezoneOffset(),
            { path: "/" }
        );
        this.cookieService.set(
            "Z_Client_TimeZone",
            this.tzHelper.getTimezone(),
            { path: "/" }
        );
        this.cookieService.set(
            "Z_Client_TimeZone",
            this.tzHelper.getTimezone(),
            { path: "/", domain: "score.nbcuni.com" }
        );
    }

    loadStyle(css: any[]) {
        const className = ".component-css";
        const head = this.document.getElementsByTagName("head")[0];
        setTimeout(() => {
            this.document
                .querySelectorAll(className)
                .forEach((e) => e.remove());
        }, 100);

        setTimeout(() => {
            if (css) {
                for (let i = 0; i < css.length; i++) {
                    const style = this.document.createElement("link");
                    style.className = "component-css";
                    style.rel = "stylesheet";
                    style.href = `${css[i]}`;

                    head.appendChild(style);
                }
            }
        }, 100);
    }

    preloadCache() {
        const cookieName = "preload-cache";
        const url = window.location.origin + "/api/preloadcache";
        if (!this.cookieService.get(cookieName)) {
            return this.http
                .get(url)
                .toPromise()
                .then((resp) => {
                    this.cookieService.set(cookieName, "complete", {
                        path: "/",
                    });
                });
        }
        return null;
    }

    ngOnInit() {
        this.setCookies();
        this._sharedData.getCss().subscribe((module) => {
            const cssmap = CssMapService.get(module);
            const arrCss = cssmap ? _.cloneDeep(cssmap.css) : [];
            this.loadStyle(arrCss);
        });
    }
}
